import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aa4d3f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "flex overflow-x-auto space-x-3 show-scroll pb-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-xs uppercase" }
const _hoisted_5 = { class: "sm:text-sm text-xl font-semibold" }
const _hoisted_6 = { class: "sm:text-xs text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.$t("date")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          ref_for: true,
          ref: "dayRef",
          onClick: ($event: any) => (_ctx.selectDate(day)),
          class: _normalizeClass([ 
          'min-w-[70px] flex-shrink-0 rounded-xl text-center cursor-pointer p-2 border transition-all optionButton',
          _ctx.selectedDate === day.date
            ? 'walletButton'
            : 'walletButtonDisabled'
        ])
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(day.month), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(day.day), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(day.weekday), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}